import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { colors, weights } from '~/styles';
import ListViewActions, { Cell as ActionsCell } from './ListViewActions';

export const Row = styled.div`
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid ${colors.grey10};

  &.is-clickable:hover,
  &.focused {
    z-index: 2;
    box-shadow: 0 3px 15px ${colors.grey10};
  }

  &.is-clickable {
    cursor: pointer;
    transition: all 250ms ease-in-out;
  }

  &.is-disabled {
    position: relative;

    &.is-disabled::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      pointer-events: none;
      z-index: 1;
    }
  }
`;

const RowContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const RowCells = styled.div`
  flex: 1;
  display: flex;
  align-items: stretch;
`;

const TotalRow = styled(Row)`
  border-bottom: none;
  font-weight: ${weights.bold};

  /* The actions cell rules itself off independently of the row, so clear that too or the line survives. */
  ${ActionsCell} {
    border-bottom: none;
  }
`;

const withColumnIndexes = (children) =>
  React.Children.toArray(children).map((child, index) => React.cloneElement(child, { index }));

const isActions = (child) => child.type === ListViewActions;

function ListViewRow({ className, isDisabled, onClick, footer, children, ...props }) {
  const cells = withColumnIndexes(children);

  return (
    <Row
      {...props}
      className={classNames(className, { 'is-disabled': isDisabled, 'is-clickable': !!onClick })}
      onClick={onClick}>
      {footer ? (
        <>
          <RowContent>
            <RowCells>{cells.filter((child) => !isActions(child))}</RowCells>
            {footer}
          </RowContent>
          {cells.filter(isActions)}
        </>
      ) : (
        cells
      )}
    </Row>
  );
}

function ListViewTotalRow({ children, ...props }) {
  return <TotalRow {...props}>{withColumnIndexes(children)}</TotalRow>;
}

export default ListViewRow;
export { ListViewTotalRow };
